import { render } from "./PriceBox.vue?vue&type=template&id=ee4144e8&scoped=true"
import script from "./PriceBox.vue?vue&type=script&lang=js"
export * from "./PriceBox.vue?vue&type=script&lang=js"

import "./PriceBox.vue?vue&type=style&index=0&id=ee4144e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee4144e8"]])

export default __exports__